import React, { Fragment, useState, useContext } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Navigate } from "react-router-dom";

import { makeStyles } from "@mui/styles";
import axios from "axios";
import {
  FormControl,
  Slide,
  Snackbar,
  TextField,
  Grid,
  DialogActions,
  DialogContent,
  Alert,
  Dialog,
  FormHelperText,
} from "@mui/material";
import {
  MailOutline,
  StorefrontOutlined,
  PercentOutlined,
} from "@mui/icons-material";

import {
  cardBodyStyle,
  ButtonLoadinStyle,
  ButtonExit,
} from "components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

export default function EditClientsAdmin(props) {
  const classes = useStyles();

  const [openAlertSuccess, setopenAlertSuccess] = useState(false);
  const [mensaje_success, setmensaje_success] = useState("");
  const [returnLogin, setReturnLogin] = React.useState(false);
  const [error, setError] = useState(false);
  const [mensageSystem, setMensageSystem] = useState("");
  const [disable, setDisable] = useState(true);
  const [loader, setLoader] = useState(false);

  const [alert, setAlert] = React.useState({
    openAlert: false,
    errorAlert: "error",
    mensaje: "",
  });

  const { urlServices, UserAuth } = useContext(UrlServicesContext);

  let keyAuthorization = UserAuth.Session;

  const dataInfo = props.id.row;

  const [values, setValues] = useState({
    companyName: dataInfo.companyName,
    document_id: dataInfo.documentId,
    email: dataInfo.email,
    emailRegister: dataInfo.email,
    phone: dataInfo.phone,
    percentage: dataInfo.percentage,
    domain: dataInfo.domain || null,
    domainNew: dataInfo.domain || null,
    nameBank: dataInfo.nameBank,
    numberAccountBank: dataInfo.numberAccountBank,
    errorCompanyName: false,
    errorEmail: false,
    errorPhone: false,
    errorPercentage: false,
  });

  const handleChange = (prop, value) => {
    setValues((prevValues) => ({
      ...prevValues,
      [prop]: value,
      errorCompanyName: false,
      errorEmail: false,
      errorPhone: false,
      errorPercentage: false,
    }));

    setAlert((prevAlert) => ({
      ...prevAlert,
      openAlert: false,
    }));

    setDisable(false);
  };

  const handleCloseDialog = (pro) => (event) => {
    props.exit();
  };

  // Expresión regular para validar el formato de correo
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const submitForm = (e) => {
    e.preventDefault();
    setError(false);
    setopenAlertSuccess(false);

    if (values.companyName.length === 0) {
      setValues({ ...values, errorCompanyName: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "Debe agregar un nombre del cliente",
      });

      return;
    }

    if (values.email.length === 0) {
      setValues({ ...values, errorEmail: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "Debe agregar un correo electrónico",
      });
      return;
    }

    if (!emailRegex.test(values.email)) {
      setValues({ ...values, errorEmail: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: `Debe ingresar un correo electrónico válido`,
      });
      return; // Salir si hay un error
    }

    if (values.phone === "") {
      setValues({ ...values, errorPhone: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "Debe agregar un teléfono",
      });
      return;
    }

    if (values.percentage === "") {
      setValues({ ...values, errorPercentage: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "Debe agregar un porcentaje de comisión",
      });
      return;
    }

    setLoader(true);

    const dataValue = {
      documentId: values.document_id,
      companyName: values.companyName,
      phone: values.phone,
      percentage: values.percentage,
      nameBank: values.nameBank,
      numberAccountBank: values.numberAccountBank,
      domain:
        values.domain !== values.domainNew ? values.domainNew : values.domain,
    };

    if (values.email !== values.emailRegister) {
      dataValue.email = values.email.toLowerCase().trim();
    }

    if (values.domain !== values.domainNew) {
      dataValue.domainNew = values.domainNew || null;
    }

    axios
      .put(`${urlServices}clients/${dataInfo.id}`, dataValue, {
        headers: {
          Authorization: "Bearer " + keyAuthorization,
        },
      })
      .then((response) => {
        setDisable(true);
        setopenAlertSuccess(true);
        setmensaje_success("Cliente actualizado con éxito.");
        props.callBackRefresh();
        setLoader(false);
      })
      .catch((e) => {
        if (e.response.status === 409) {
          setValues({ ...values, errorEmail: true });
          setMensageSystem("Correo electrónico ya registrado.");
          setError(true);
        } else if (e.response.status === 401) {
          setMensageSystem(
            "La sesión ha expirado, vuelva a iniciar sesión ...",
          );
          setError(true);

          setTimeout(() => {
            localStorage.clear();
            setReturnLogin(true);
          }, 4000);
        } else if (e.response.status === 500) {
          setMensageSystem("Error en la consulta con sel servidor.");
          setError(true);
        }
        setLoader(false);
      });
  };

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({ openAlert: false });
  };

  if (returnLogin) {
    return <Navigate to="/" />;
  }

  return (
    <Fragment>
      <Dialog
        fullWidth
        onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        keepMounted
        scroll="body"
        PaperProps={{
          sx: {
            borderRadius: 6,
          },
        }}
      >
        <DialogContent dividers className={classes.styleDialogContent}>
          <Fragment>
            <Grid container spacing={1} className={classes.containerProfile}>
              <Grid item xs={12} sm={12}>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12}>
                    {error && <Alert severity="error">{mensageSystem}</Alert>}
                    <div className={classes.titleCardFilter}>
                      Editar cliente
                    </div>
                    <div className={classes.lineBottom}></div>
                  </Grid>
                  <Grid item xs={12} sm={12} sx={{ marginTop: 1 }}>
                    <b
                      className={classes.cardTitleBlack}
                      style={{ fontSize: 14, fontWeight: 500 }}
                    >
                      Cliente
                    </b>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl style={{ width: "100%" }}>
                      <TextField
                        name="companyName"
                        value={values.companyName}
                        error={values.errorCompanyName}
                        onChange={(event) =>
                          handleChange("companyName", event.target.value)
                        }
                        fullWidth
                        required
                        label="Nombre"
                        margin="dense"
                        autoComplete="off"
                        variant="outlined"
                        size="small"
                        InputProps={{
                          endAdornment: (
                            <StorefrontOutlined
                              fontSize="small"
                              className={classes.iconInput}
                              position="end"
                            ></StorefrontOutlined>
                          ),
                        }}
                        helperText="Nombre de la empresa."
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl style={{ width: "100%" }}>
                      <TextField
                        name="document_id"
                        value={values.document_id}
                        error={values.errorDocument}
                        onChange={(event) =>
                          handleChange("document_id", event.target.value)
                        }
                        fullWidth
                        size="small"
                        label="RUC"
                        margin="dense"
                        variant="outlined"
                        autoComplete="off"
                        inputProps={{
                          style: {
                            textAlign: "center",
                          },
                          maxLength: 13,
                        }}
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(
                            /[^0-9]/g,
                            "",
                          );
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={7}>
                    <TextField
                      autoComplete="off"
                      name="Correo electrónico"
                      value={values.email}
                      onChange={(event) =>
                        handleChange("email", event.target.value)
                      }
                      label="Email"
                      error={values.errorEmail}
                      InputProps={{
                        endAdornment: (
                          <MailOutline
                            fontSize="small"
                            className={classes.iconInput}
                            position="end"
                          ></MailOutline>
                        ),
                      }}
                      fullWidth
                      margin="dense"
                      required
                      variant="outlined"
                      size="small"
                      helperText="Correo electrónico para el acceso."
                    />
                  </Grid>
                  <Grid item xs={12} sm={5}>
                    <FormControl style={{ width: "100%" }}>
                      <TextField
                        name="phone"
                        value={values.phone}
                        error={values.errorPhone}
                        onChange={(event) =>
                          handleChange("phone", event.target.value)
                        }
                        fullWidth
                        required
                        size="small"
                        label="Teléfono"
                        margin="dense"
                        autoComplete="off"
                        variant="outlined"
                        inputProps={{ maxLength: 14 }}
                      />
                      <FormHelperText style={{ fontSize: 11 }}>
                        Con prefijo del país ejemplo: +593
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <b
                      className={classes.cardTitleBlack}
                      style={{ fontSize: 14, fontWeight: 500 }}
                    >
                      Configuración
                    </b>
                  </Grid>
                  <Grid item xs={12} sm={5}>
                    <b
                      className={classes.cardTitleBlack}
                      style={{ fontSize: 12, fontWeight: 500, color: "#000" }}
                    >
                      Porcentaje comisión
                    </b>
                    <TextField
                      name="percentage"
                      value={values.percentage}
                      onChange={(event) =>
                        handleChange("percentage", event.target.value)
                      }
                      error={values.errorPercentage}
                      fullWidth
                      required
                      size="small"
                      label="Comisión"
                      margin="dense"
                      variant="outlined"
                      autoComplete="off"
                      inputProps={{
                        style: {
                          textAlign: "center",
                        },
                        maxLength: 3,
                      }}
                      type="number"
                      InputProps={{
                        endAdornment: (
                          <PercentOutlined
                            fontSize="small"
                            className={classes.iconInput}
                            position="end"
                          ></PercentOutlined>
                        ),
                      }}
                      //  helperText="Si no se sabe el porcentaje de la comisión, colocar 0."
                    />
                    <Alert severity="info" icon={false} sx={{ fontSize: 12 }}>
                      Fee de cobro al cliente.
                    </Alert>
                  </Grid>
                  <Grid item xs={12} md={7}>
                    <b
                      className={classes.cardTitleBlack}
                      style={{ fontSize: 12, fontWeight: 500, color: "#000" }}
                    >
                      Dominio DNS del cliente (Para dar permiso a la URL)
                    </b>
                    <TextField
                      name="domainNew"
                      variant="outlined"
                      value={values.domainNew}
                      onChange={(event) =>
                        handleChange("domainNew", event.target.value)
                      }
                      type="text"
                      autoComplete="off"
                      margin="dense"
                      fullWidth
                      size="small"
                      inputProps={{ maxLength: 100 }}
                      placeholder="Ingresar..."
                      helperText="Ejemplos: hotelmiramar.com, mi-hotel.com.ec, hotelqq.net, posadameta.org"
                      error={
                        !!values.domainNew &&
                        !/^(?!:\/\/)([a-zA-Z0-9-]{1,63}\.)+[a-zA-Z]{2,}$/.test(
                          values.domainNew.toLowerCase(),
                        )
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <b
                      className={classes.cardTitleBlack}
                      style={{ fontSize: 14, fontWeight: 500 }}
                    >
                      Información bancaria{" "}
                      <b style={{ color: "red", fontSize: 10, marginLeft: 10 }}>
                        {dataInfo.numberAccountBank === ""
                          ? "(SIN CUENTA BANCARIA REGISTRADA)"
                          : ""}
                      </b>
                    </b>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      name="nameBank"
                      value={values.nameBank}
                      onChange={(event) =>
                        handleChange("nameBank", event.target.value)
                      }
                      fullWidth
                      required
                      size="small"
                      label="Nombre del banco"
                      margin="dense"
                      variant="outlined"
                      autoComplete="off"
                      type="text"
                      //  helperText="Si no se sabe el porcentaje de la comisión, colocar 0."
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      name="numberAccountBank"
                      value={values.numberAccountBank}
                      onChange={(event) =>
                        handleChange("numberAccountBank", event.target.value)
                      }
                      fullWidth
                      required
                      size="small"
                      label="Número de cuenta"
                      margin="dense"
                      variant="outlined"
                      autoComplete="off"
                      type="text"
                      //  helperText="Si no se sabe el porcentaje de la comisión, colocar 0."
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <br></br>
                    <center>
                      <ButtonLoadinStyle
                        type="submit"
                        onClick={submitForm}
                        disabled={disable}
                        loading={loader}
                        // loadingIndicator="Registrando…"
                        variant="outlined"
                      >
                        Guardar
                      </ButtonLoadinStyle>
                    </center>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <center>
                      {openAlertSuccess && (
                        <Alert severity="success">{mensaje_success}</Alert>
                      )}
                    </center>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {alert.openAlert && (
              <Snackbar
                open={true}
                autoHideDuration={6000}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                onClose={handleCloseAlert}
              >
                <Slide direction="up" in={true} mountOnEnter unmountOnExit>
                  <Alert
                    onClose={handleCloseAlert}
                    severity={
                      alert.errorAlert === "error" ? "error" : "success"
                    }
                    elevation={6}
                    variant="filled"
                  >
                    {alert.mensaje}
                  </Alert>
                </Slide>
              </Snackbar>
            )}
          </Fragment>
        </DialogContent>
        <DialogActions>
          <ButtonExit onClick={handleCloseDialog(true)}>Cerrar</ButtonExit>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
